<template>
  <div class="order">
    <Flex :title="`${record.title}`" :data="'¥' + record.order_price" :isHeader="true" />
    <div class="content">
      <Flex title="购课用户" :data="record.name" :gravatar="record.gravatar" />
      <Flex title="课程场次" :data="record.event_title" />
      <Flex title="支付时间" :data="$moment(record.pay_time).format('YYYY-MM-DD HH:mm')" />
      <div @click="goRefund(record.refund)" v-if="!record.wait && record.refund.id">
        <Flex
          v-if="record.refund.status != 5"
          title="邀请奖励"
          :data="'¥' + record.refund.refund_amount"
        />
        <Flex v-else title="邀请奖励" data="已兑换课时" />
      </div>
      <Flex
        v-if="record.user_type > 1"
        title="邀请身份"
        :data="$store.state.info.identity[record.user_type]"
      />
      <div
        @click="goRefund(record.refund)"
        class="button"
        v-if="
          record.refund.id &&
            record.refund.status != 2 &&
            record.refund.status != 3 &&
            record.refund.status != 5 &&
            !$moment().isAfter(record.refund.end_time)
        "
      >去提现</div>
      <!-- <div v-if="!record.wait && record.refund.id">
        <div class="button" v-if="record.refund.status != 5" @click="goRefund(record.refund)">
          {{ getRefundText(record.refund.type) }} ¥{{ record.refund.refund_amount }}
          <i
            v-if="record.refund.status == 2"
            class="anyteachicon anyteach-check-circle"
          />
        </div>
        <div class="button" @click="goRefund(record.refund)" v-else>
          已兑换课时
          <i class="anyteachicon anyteach-check-circle" />
        </div>
        <p v-if="record.refund.status == 1" class="cashout" @click="goRefund(record.refund)">
          <span v-if="$moment().isBefore(record.refund.end_time)">去提现</span>
          <span v-else>已过期</span>
        </p>
      </div>-->
    </div>
  </div>
</template>
<script>
import Flex from "./Flex"

export default {
  name: "OrderItem",
  props: ["record"],
  components: { Flex },
  methods: {
    goRefund(refund) {
      if (this.$moment().isAfter(refund.end_time)) return
      this.$router.push({
        path: "/cash/" + refund.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.order {
  background: white;
  box-shadow: $deep-shadow;
  border-radius: 4px;
  border: $border;
  padding: 10px 10px;
  margin: 0 0 10px 0;
  width: 95%;
  &:first-of-type {
    margin-top: 15px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
}

.button {
  text-align: center;
  color: $red;
  @include avenir-demi();
  font-size: 0.9rem;
  transition: all 0.1s;

  &:active {
    opacity: 0.6;
  }
}
</style>
